<template>
  <div class="bg_base">
    <div class="temp_wave">
      <img
        src="../../assets/img/V.1 020921 Journey Background Wave Comp0.png"
        width="100%"
        alt=""
      />
    </div>
    <div class="temp_result">
      <div class="pb-3"></div>
      <section class="logo d-flex justify-center">
        <img src="../../assets/img/logo-teman-bakat.png" height="90px" alt="" />
      </section>
      <section class="logo d-flex justify-center">
        <img
          src="../../assets/img/inconsistency/Misi Inconsistency-Judul Report Journey.png"
          height="90px"
          alt=""
        />
      </section>
      <section class="pa-3">
        <div class="d-flex justify-center">
          <img
            src="../../assets/img/inconsistency/Misi Inconsistency - Icon Template.png"
            height="200px"
            alt=""
          />
        </div>
        <section class="text-justify pa-3">
          {{ result.deskripsi }}
        </section>
      </section>
    </div>
    <uiDownload />
  </div>
</template>

<script>
import uiDownload from "../downloadScheme/uiDownload.vue";
export default {
  components: { uiDownload },
  name: "resultInconsitency",
  data() {
    return {
      result: "",
    };
  },
  mounted() {
    let data = JSON.parse(localStorage.getItem("tesbidangpekerjaan"));
    this.result = JSON.parse(data.result);
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.bg_base {
  position: relative;
  background: url("../../assets/img/Misi1-3-2Report Background.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
}
.logo {
  margin-bottom: 30px;
}
.temp-pyramid {
  position: relative;
}
.type {
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.temp_wave {
  top: 0;
  position: absolute;
}
.temp_result {
  position: relative;
  z-index: 2;
}
</style>
